import { useMemo } from "preact/hooks";
import { useSignal, useSignalEffect } from "@preact/signals";
import { local } from "~/core";
import { UseLocalFn } from "./interfaces";

const useLocal: UseLocalFn = <T extends object>(
    key: string,
    defaultValue: T | null = null,
    skip = false,
) => {
    const { get, set, clear } = useMemo(() => {
        // This check is to only satisfy TS doesn't change anything
        if (defaultValue === null) {
            return local<T>(key, defaultValue);
        }

        return local<T>(key, defaultValue);
    }, [key, defaultValue]);

    const value = useSignal<T | null>(get());

    useSignalEffect(() => {
        const v = value.value;

        if (skip) {
            return;
        }

        if (v === null) {
            clear();
            return;
        }

        set(v);
    });

    return value;
};

export default useLocal;
